import React from 'react';
import { Launcher } from 'react-chat-window';
import './style.css';
import {
    Link
} from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import {
    Container,
    Title,
    Description,
    Content,
    NewLine,
    Point
} from './style';
import { ApiAiClient } from 'api-ai-javascript';
const accessToken = '24e05a21d3bc4b868f2b1ea7c2d90b45';

const client = new ApiAiClient({ accessToken });

class DialogflowChatbot extends React.Component {
    constructor() {
        super();
        this.state = {
            // messageList: messageHistory,
            messageList: '',
            newMessagesCount: 0,
            isOpen: false,
            loadingBarProgress: Math.random() * 100
        };
    }

    complete = () => {
        this.setState({ loadingBarProgress: 100 });
    };

    onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
    };

    componentDidMount() {
        this.complete();
    }

    _onMessageWasSent(message) {
        console.log("_onMessageWasSent: " + JSON.stringify(message));
        client.textRequest(message.data.text)
            .then((response) => {
                console.log("Response: " + response.result.fulfillment.speech)
                let retrievedMessage = { "author": "them", "type": "text", "data": { "text": response.result.fulfillment.speech } }
                this.setState({
                    messageList: [...this.state.messageList, retrievedMessage]
                });
            })
            .catch((error) => {

            })

        this.setState({
            messageList: [...this.state.messageList, message]
        });
    }

    _handleClick() {
        this.setState({
            isOpen: !this.state.isOpen,
            newMessagesCount: 0
        });
    }

    render() {
        return (
            <Container>
                <LoadingBar
                    progress={this.state.loadingBarProgress}
                    height={3}
                    color='#fff'
                    onLoaderFinished={() => this.onLoaderFinished()}
                />
                <Link to="/"><Title> {"{"} nightbot.dev {"}"} </Title></Link>
                <Description> Dialogflow Chatbot </Description>
                <Content>
                    <Point>Case Study:</Point>
                    <NewLine />
                    Dialogflow is one of the most popular NLU (Natural Language Understanding) platform to design and integrate a conversational user interface into mobile apps, web applications, devices, bots, interactive voice response systems, and so on. This project is an example of the integration of web-based chatbot with Dialogflow.
                    <NewLine />
                    <NewLine />
                    You are the owner of a coffee shop ☕, and you would like to provide a better experience for your customer.
                    <NewLine />
                    <NewLine />
                    <Point>Feature(s):</Point>
                    <NewLine />
                    Dialogflow (formerly Api.ai)
                    <NewLine />
                    <NewLine />
                    <Point>How-To:</Point>
                    <NewLine />
                    Click the chat icon on the bottom right of the page, and then try to greet the chatbot.
                </Content>

                <div className="chatWrapper">
                    <Launcher
                        agentProfile={{
                            teamName: 'Dialogflow Chatbot',
                        }}
                        onMessageWasSent={this._onMessageWasSent.bind(this)}
                        messageList={this.state.messageList}
                        handleClick={this._handleClick.bind(this)}
                        isOpen={this.state.isOpen}
                        showEmoji={false}
                    />
                </div>
            </Container>
        )
    }
}

export default DialogflowChatbot;